<div class="grid grid-cols-2 gap-3">
  <app-details-view label="Identyfikator">
    {{ id() }}
  </app-details-view>

  <app-details-view label="Numer przyjęcia">
    {{ number() }}
  </app-details-view>

  <app-details-view label="Data utworzenia">
    <app-date [date]="createdAt()" />
  </app-details-view>

  <app-details-view label="Data przyjęcia">
    <app-date [date]="receiptedAt()" />
  </app-details-view>

  <app-details-view label="Data zatwierdzenia">
    @if (isNotNil(approvedAt())) {
      <app-date [date]="approvedAt()!" />
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Status">
    <app-warehouse-receipt-status [status]="status()" />
  </app-details-view>

  <div class="col-span-2">
    <app-details-view label="Komentarz">
      @if (isNotNil(comment())) {
        {{ comment() }}
      } @else {
        <app-no-data />
      }
    </app-details-view>
  </div>
</div>
